import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { CountryProvincesResponse, MiscApi } from '@shared/api/rest/misc';
import { ApiUtils } from '@shared/utils';
import { IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams) => MiscApi.getCountryProvinces(params.signal));
const clearEvent = createEvent();

const $dataStore = createStore<CountryProvincesResponse>({})
  .on(effect.done, (_, data) => data.result.data ?? {})
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);

export const $countryProvincesStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
